import React, { useState, createRef, useEffect } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Paper,
} from "@mui/material";
import API from "../../api/index";
import renderNotification from "../../utils/notification-handler";
import { ReactNotifications } from "react-notifications-component";
import Background from "../../components/Background";


const Verification = ({ setTipo, tipo }) => {
  const mfa = sessionStorage.getItem("mfa") || "";
  const [inputs, setInputs] = useState(Array(6).fill(""));
  const inputRefs = Array(6)
    .fill()
    .map(() => createRef());

  const [from] = useState();

  if (from === `/${tipo}/login`) {
    window.location.href = `/`;
  }

  const [timeLeft, setTimeLeft] = useState(174); // Assumed time left for demonstration

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prevTimeLeft) => (prevTimeLeft > 0 ? prevTimeLeft - 1 : 0));
    }, 1000);

    API.getVerifyPage({})
      .then((response) => { })
      .catch((error) => {
        window.sessionStorage.removeItem("type");
        window.sessionStorage.removeItem("mfa");
        //window.location.href = "/";
      });

    return () => clearInterval(interval);
  }, []);

  const handleChange = (value, index) => {
    const newInputs = [...inputs];
    newInputs[index] = value.replace(/\D/g, ""); // Sostituire con un numero se non è un numero
    setInputs(newInputs);

    if (newInputs[index].length === 1 && index < 5) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && inputs[index] === "") {
      inputRefs[index - 1].current.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").split("");
    const newInputs = [...inputs];
    pasteData.forEach((char, i) => {
      if (i < 6) {
        newInputs[i] = char.replace(/\D/g, "");
      }
    });
    setInputs(newInputs);

    newInputs.forEach((input, index) => {
      if (inputRefs[index].current) {
        inputRefs[index].current.value = input;
      }
    });

    if (newInputs[5]) {
      inputRefs[5].current.focus();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const combinedValue = inputs.join("");

    API.post2FA({
      code: combinedValue,
    })
      .then(() => {
        sessionStorage.removeItem("mfa");
        if (tipo === "user") {
          window.location.href = `/${tipo}/home`;
        } else {
          window.location.href = `/${tipo}/home`;
        }
      })
      .catch(() => {
        renderNotification(
          "error",
          "Error",
          "The code you entered is wrong"
        );
      });
  };

  const handleClickResendCode = () => {
    API.postResend2FA({}).then((response) => {
      setTimeLeft(174);
    });
  };

  const handleSendEmailCode = () => {
    sessionStorage.setItem("mfa", "email");
    API.SendEmailCode({}).then((res) => {
      window.location.reload();
    }).catch((err) => {
      window.location.reload();
    })
  }

  return (
    <>
      <Background />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <ReactNotifications />
        <Container component="main" maxWidth="xs">
          <Paper
            sx={{
              mt: 4,
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#000",
              border: "solid 2px #49BECE",
              borderRadius: "10px",
            }}
          >
            <Box display="flex" alignItems="center" marginBottom="20px">
              <img
                src="/logoWhite.png"
                alt="LECS Logo"
                style={{
                  maxWidth: "40px",
                  height: "auto",
                  marginRight: "10px",
                }}
              />
              <Typography variant="h4" component="h2" fontWeight={700}>
                LECS
              </Typography>
            </Box>
            <Typography variant="h3" fontWeight={700}>Enter the code</Typography>
            {mfa === "email" ? (
              <Typography variant="body1" fontWeight={600}>
                A 6-digit verification code was sent to the email address.
              </Typography>
            ) : mfa === "authenticator" && (
              <Typography variant="body1" fontWeight={600}>
                A 6-digit verification code was on your authenticator app.
              </Typography>
            )}
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1, display: "flex", flexDirection: "column", alignItems: "center" }}
            >
              <div className="inputs-container-2fa">
                {inputs.map((input, index) => (
                  <input
                    key={index}
                    ref={inputRefs[index]}
                    type="text"
                    value={input}
                    maxLength={1}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    className="auth-input-2fa"
                    autoComplete="off"
                  />
                ))}
              </div>
              <Button
                sx={{
                  mt: 3,
                  mb: 2,
                  fontWeight: "bold",
                  backgroundColor: "#2d2d2d",
                  "&:hover": {
                    backgroundColor: "#eaeaea !important",
                    color: "#131C2D",
                  },
                }}
                type="submit"
                variant="contained"
              >
                VERIFICATION
              </Button>
            </Box>
            {mfa === "email" ? (<Button
              onClick={handleClickResendCode}
              style={{
                textTransform: "none",
                padding: 0,
                margin: 0,
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <Typography
                variant="body2"
                style={{ marginTop: "8px", textDecoration: "underline", color: 'white' }}
              >
                Send the code again. {timeLeft} seconds
              </Typography>
            </Button>
            ) : mfa === "authenticator" && (
              <Button
                onClick={handleSendEmailCode}
                style={{
                  textTransform: "none",
                  padding: 0,
                  margin: 0,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ marginTop: "8px", textDecoration: "underline", color: 'white' }}
                >
                  Send email with code
                </Typography>
              </Button>
            )}
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Verification;
